import { motion, AnimatePresence } from 'framer-motion';
import { BadgeProgressRing, getBadgeState, BADGE_CONFIGS } from '../BadgeProgressRing';

const BADGE_ORDER = ['charter', 'trader', 'officer', 'researcher', 'collector', 'organized'];

const AllBadgesModal = ({ isOpen, onClose, badgeData, theme }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '20px',
        }}
        onClick={onClose}
      >
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 50, scale: 0.95 }}
          transition={{ type: 'spring', damping: 25, stiffness: 300 }}
          style={{
            backgroundColor: theme.bgCard,
            borderRadius: '20px',
            border: `1px solid ${theme.border}`,
            width: '100%',
            maxWidth: '400px',
            maxHeight: '80vh',
            overflow: 'auto',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '20px',
            borderBottom: `1px solid ${theme.border}`,
          }}>
            <h2 style={{ fontSize: 18, fontWeight: 700, color: theme.text, margin: 0 }}>
              All Badges
            </h2>
            <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                color: theme.textSecondary,
                cursor: 'pointer',
                padding: 4,
              }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          {/* Badge List */}
          <div style={{ overflowY: 'auto', padding: '16px 20px 40px' }}>
            {BADGE_ORDER.map((type) => {
              const state = getBadgeState(type, badgeData);
              if (!state) return null;
              const config = BADGE_CONFIGS[type];

              return (
                <div
                  key={type}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 16,
                    padding: '16px 0',
                    borderBottom: `1px solid ${theme.border}`,
                  }}
                >
                  {/* Badge ring */}
                  <BadgeProgressRing
                    type={type}
                    data={badgeData}
                    size={56}
                    showLabel={false}
                    theme={theme}
                  />

                  {/* Info */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 2 }}>
                      <span style={{ fontSize: 15, fontWeight: 700, color: theme.text }}>
                        {state.label}
                      </span>
                      {state.level === 'completed' ? (
                        <span style={{
                          fontSize: 11,
                          fontWeight: 600,
                          color: '#22c55e',
                          backgroundColor: 'rgba(34, 197, 94, 0.15)',
                          padding: '2px 8px',
                          borderRadius: 6,
                        }}>
                          Completed
                        </span>
                      ) : state.level > 0 ? (
                        <span style={{
                          fontSize: 11,
                          fontWeight: 600,
                          color: state.color,
                          backgroundColor: `${state.color}20`,
                          padding: '2px 8px',
                          borderRadius: 6,
                        }}>
                          Level {state.level} - {state.count}
                        </span>
                      ) : (
                        <span style={{
                          fontSize: 11,
                          fontWeight: 600,
                          color: theme.textSecondary,
                          backgroundColor: theme.bgCard,
                          padding: '2px 8px',
                          borderRadius: 6,
                        }}>
                          {state.count}/{state.nextTarget}
                        </span>
                      )}
                    </div>

                    <span style={{ fontSize: 12, color: theme.textSecondary, lineHeight: 1.3 }}>
                      {config.oneOff
                        ? config.description
                        : state.levelDescription || config.description
                      }
                    </span>

                    {/* Progress bar */}
                    {!state.completed && (
                      <div style={{
                        marginTop: 8,
                        height: 4,
                        backgroundColor: theme.border,
                        borderRadius: 2,
                        overflow: 'hidden',
                      }}>
                        <div style={{
                          height: '100%',
                          width: `${state.progress * 100}%`,
                          backgroundColor: state.level > 0 ? state.color : '#4a5568',
                          borderRadius: 2,
                          transition: 'width 0.3s ease',
                        }} />
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default AllBadgesModal;
